<template>
  <div class="notice-report">
    <div class="header">
      <div class="bg"></div>
    </div>
    <nav-title title="·声明及承诺"></nav-title>
    <div class="content">
      新希望集团审计监察部为董事会领导之独立监督机构，负
      责公司反舞弊渠道的维护以及案件的调查。我们本着对董
      事会及举报人负责的态度开展反舞弊工作，承诺对举报
      者的个人信息及举报内容进行严格保密。
    </div>
    <nav-title title="·举报范围"></nav-title>
    <div class="content">
      “廉洁举报”仅限于对新希望员工违反《新希望集团商业行 为准则》行为的举报。
    </div>
    <nav-title title="·举报责任"></nav-title>
    <div class="content">
      1.举报人应遵守国家法律法规，不得损害他人合法利益。
      2.举报内容应当客观公正，不得捏造、歪曲事实，不得陷害他人。
    </div>
    <nav-title title="·重要提醒"></nav-title>
    <div class="content">
      1.鼓励实名举报，我们承诺对实名举报的个人信息及举报
      内容严格保密，并对调查结果给予及时反馈。
      2.举报人应尽可能说明事情的基本经过，举报对象的名称、
      地址、具体当事人，并提供个人利益或公司利益受到侵害 的证据或相关资料。
    </div>
  </div>
</template>

<script>
import navTitle from '../../recruitment-info/components/recruit-title';
export default {
  components: {
    navTitle
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: 180px;
  padding: 32px 16px 0px 32px;
  .bg {
    background: url('../../../common/images/visa-change/report.png') no-repeat;
    background-size: 702px 150px;
    height: 150px;
  }
}
.content {
  color: #666;
  font-size: 28px;
  padding: 24px 24px 20px 32px;
  line-height: 1.8;
}
</style>
